import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { EmployeeProvider } from './contexts/EmployeeContext';
import { PanelThemeProvider } from './theme/PanelThemeProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <AuthProvider>
        <EmployeeProvider>
            {/* MGMT-PANEL-BUILD-SHELL-01: one theme (src/theme/united.js), light by default, dark via the header toggle */}
            <PanelThemeProvider>
                <Router>
                    <App />
                </Router>
            </PanelThemeProvider>
        </EmployeeProvider>
    </AuthProvider>
);

reportWebVitals();
